{
  "alert.informative": "Informative",
  "alert.negative": "Negative",
  "alert.notice": "Notice",
  "alert.positive": "Positive",
  "chat.newMessage": "새 메시지",
  "chat.scrollToBottom": "맨 아래로 스크롤",
  "messagefeedback.thumbDown": "잘못된 응답",
  "messagefeedback.thumbUp": "양호한 응답",
  "promptfield.aiDisclaimer": "응답은 AI를 이용하여 생성되며, 부정확할 수 있으니 사용하기 전에 확인하십시오. ",
  "promptfield.aiUserGuidlines": "AI 사용자 가이드라인",
  "promptfield.attachments": "첨부 파일",
  "promptfield.insertButton": "추가",
  "promptfield.label": "프롬프트",
  "promptfield.placeholder": "시작할 준비가 되셨습니까? 질문을 하거나, 아이디어를 공유하거나, 작업을 추가하세요.",
  "promptfield.placeholder.small": "Ask anything",
  "promptfield.stopButton": "중단",
  "promptfield.submitButton": "전송",
  "promptfield.uploading": "업로드",
  "responsestatus.loading": "로드 중",
  "responsestatus.processing": "Processing...",
  "voicebutton.startListening": "기록 시작",
  "voicebutton.stopListening": "기록 중지",
  "attachmentlist.previousAttachments": "Show previous attachments",
  "attachmentlist.nextAttachments": "Show next attachments"
}
